module.exports = __webpack_public_path__ + "static/media/student-end-season-brown.44de4a14.png";